import axios from "@/plugins/axios";

export default {
  getDataList() {
    // 获取资料下载的列表
    return axios.get("data/getDataList");
  },
};
